export const defaultTheme = {
	purplePrimary: '#9036F7',
	purpleSecundary: '#9E37E2',
	purpleAux: '#4D2767',
	background: '#F5F0F8',
	white: '#fff',
	gray: '#A3A3A3',
	black: '#333333',
	darkGray: '#606060'
}

export const mutantColors = {
	purple_1: '#A160EB',
	purple_2: '#9036F7',
	purple_3: '#843BD8',
	l_blue_1: '#4CBDD4',
	l_blue_2: '#22A7C2',
	l_blue_3: '#168CA4',
	l_blue_4: '#3FE4C7',
	d_blue_1: '#4A4AFC',
	d_blue_2: '#2D2D8C',
	d_blue_3: '#213F5B',
	d_blue_4: '#102941',
	d_blue_5: '#0D2337',
	green_1: '#33D258',
	red_1: '#E64F40',
	grayscale_1: '#B9C1C9',
	grayscale_2: '#7E8B98',
	grayscale_3: '#6A7682',
	grayscale_4: '#E1E1E1',
	grayscale_5: '#F8F8F8',
	black_1: '#000000',
	black_2: '#333333',
	yellow_1: '#FFA318',
	white_1: '#FFFFFF',
	orange_1: '#FF4500',
};

export default defaultTheme;